import { FiSearch, FiUser, FiUsers } from "react-icons/fi";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { makeRequestAuth } from "../../_config/api";
import { Link } from "react-router-dom";
const webBaseUrl = typeof window !== "undefined" && window.location.hostname === "localhost" 
  ? "http://localhost:3000" 
  : "https://propertyleinnovation.com";


function AllProperties() {
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [expandedRows, setExpandedRows] = useState({});
  const [assignModal, setAssignModal] = useState({ open: false, propertyId: null, currentOwner: "" });
  const [verifyModal, setVerifyModal] = useState({
    open: false,
    propertyId: null,
  });

  const [deleteModal, setDeleteModal] = useState({
    open: false,
    propertyId: null,
  });

    const [disableModal, setDisableModal] = useState({ open: false, propertyId: null });

  const [metaModal, setMetaModal] = useState({
    open: false,
    propertyId: null,
    title: "",
    description: "",
  });

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const pageSize = 10;
  const maxVisiblePages = 5;

  const [filters, setFilters] = useState({
    keyword: "",
    year: "",
    type: "All",
    month: "All",
    category: "",
  });
  const [propertiesType, setPropertiesType] = useState("All");

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const resData = {
        keyWord: filters.keyword,
        fromDate: "",
        toDate: "",
        status: "approved",
        isDisable: false,
        sortOrder: "desc",
        sortBy: "updatedAt",
        pageNo,
        size: pageSize,
        location: "",
        propertyType:
          propertiesType === "All" ? "" : propertiesType.toLowerCase(),
        listingCategory: filters.category && filters.category.toLowerCase(),
        price: "",
        area: "",
      };

      const response = await makeRequestAuth(
        "post",
        "/admin/getPropertyList",
        resData
      );
      setProperties(response.data.list || []);
      setTotalCount(response.data.total || 0);
    } catch (error) {
      console.error("Error fetching properties:", error);
      showErrorToast("Failed to fetch properties. Please try again later.");
      return;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageNo, filters, propertiesType]);

    const handleStatusChange = async (id, newStatus) => {
    if (newStatus === "disable") {
      setDisableModal({ open: true, propertyId: id });
      return;
    }

    try {
      const response = await makeRequestAuth(
        "post",
        "/admin/updatePropertyStatus",
        {
          propertyId: id,
          status: newStatus,
        }
      );

      const resData = response?.data;

      if (resData?.error) {
        showErrorToast(resData?.error || "Something went wrong");
        return;
      }

      showSuccessToast("Property status updated successfully!");
      fetchData();
    } catch (error) {
      console.error("Error updating property status:", error);

      const errorMessage =
        error?.response?.data?.message.status ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update property status. Please try again later.";

      showErrorToast(errorMessage);
    }
  };

  const confirmDisableProperty = async () => {
    try {
      const response = await makeRequestAuth("post", "/admin/updatePropertyDisable", {
        id: disableModal.propertyId
      });

      if (response?.error || response?.data?.error) {
        showErrorToast(response?.error || response?.data?.error || "Failed to disable property");
        return;
      }

      showSuccessToast("Property disabled successfully!");
      setDisableModal({ open: false, propertyId: null });
      fetchData();
    } catch (err) {
      showErrorToast("Error disabling property");
    }
  };


  const handleUpdateAssignment = async (id, assignedTo) => {
    try {
      await makeRequestAuth("post", "/admin/handelPropertyByStatus", {
        propertyId: id,
        status: assignedTo,
      });
      showSuccessToast(`Property assigned to ${assignedTo}`);
      setAssignModal({ open: false, propertyId: null });
      fetchData();
    } catch (error) {
      showErrorToast("Failed to update assignment.");
    }
  };

  async function handleSaveMeta() {
    try {
      let response = await makeRequestAuth(
        "post",
        "/admin/addMetaTagsInProperty",
        {
          id: metaModal.propertyId,
          title: metaModal.title,
          description: metaModal.description,
        }
      );

      if (response.error == true) {
        showErrorToast(response?.message || "Failed to add metadata");
        return;
      }

      showSuccessToast("Metadata saved successfully!");
      setMetaModal({
        open: false,
        propertyId: null,
        title: "",
        description: "",
      });
    } catch (error) {
      showErrorToast("Faild To Add Meta Data!");
    }
  }

  const handleDeleteProperty = async () => {
    try {
      const response = await makeRequestAuth(
        "post",
        "/admin/deleteProperty",
        {
          id: deleteModal.propertyId,
        }
      );

      if (response?.data?.error) {
        showErrorToast(response?.data?.message || "Delete failed");
        return;
      }

      showSuccessToast("Property deleted successfully!");
      setDeleteModal({ open: false, propertyId: null });
      fetchData();
    } catch (error) {
      showErrorToast("Failed to delete property");
    }
  };

  const handleVerifyProperty = async (id) => {
    try {
      const response = await makeRequestAuth(
        "post",
        "/admin/PropertyVerificationTongel",
        { propertyId: id }
      );

      if (response?.data?.error) {
        showErrorToast(response?.data?.message || "Verification failed");
        return;
      }

      showSuccessToast("Property verified successfully!");
      fetchData();
    } catch (error) {
      showErrorToast("Failed to verify property");
    }
  };


  const getPageNumbers = () => {
    const totalPages = Math.ceil(totalCount / pageSize);
    const start = Math.max(1, pageNo - Math.floor(maxVisiblePages / 2));
    const end = Math.min(start + maxVisiblePages - 1, totalPages);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <>
      <div className="p-4 bg-white shadow rounded-2xl flex flex-col gap-6">


        {/* Header & Filters */}
        <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-4 border-b border-gray-200 pb-3">
          <div>
            <h2 className="text-xl font-bold text-gray-800">
              Approved Properties
            </h2>
            <span className="text-sm text-gray-500">Total {totalCount}</span>
          </div>

          <div className="flex flex-wrap w-full lg:w-auto gap-4">
            {/* Search */}
            <div className="relative w-full sm:w-40">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                value={filters.keyword}
                onChange={(e) => {
                  setFilters((f) => ({ ...f, keyword: e.target.value }));
                  setPageNo(1);
                }}
                className="pl-10 pr-4 py-2 border border-gray-300 bg-gray-100 rounded-xl w-full focus:outline-none focus:ring-blue-500"
              />
            </div>

            <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-xl border border-gray-200 w-full sm:w-auto">
              <label className="text-sm text-gray-700 whitespace-nowrap">
                For:
              </label>
              <select
                value={filters.category}
                onChange={(e) => {
                  setFilters((f) => ({ ...f, category: e.target.value }));
                  setPageNo(1);
                }}
                className="px-4 bg-gray-100 rounded-lg focus:outline-none w-full sm:w-auto"
              >
                <option value="">All</option>
                {
                  ["Rent", "Buy"].map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))
                }
              </select>
            </div>

            {/* Type Filter */}
            <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-xl border border-gray-200 w-full sm:w-auto">
              <label className="text-sm text-gray-700 whitespace-nowrap">
                Type:
              </label>
              <select
                value={propertiesType}
                onChange={(e) => {
                  setPropertiesType(e.target.value);
                  setPageNo(1);
                }}
                className="px-4 bg-gray-100 rounded-lg focus:outline-none w-full sm:w-auto"
              >
                <option>All</option>
                {
                  ["apartment", "townhouse", "villa-compound", "land", "building",
                    "villa", "penthouse", "hotel-apartment", "floor", "studio",].map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))
                }
              </select>
            </div>
          </div>
        </div>

        {/* Property List */}
        {isLoading ? (
          <div className="flex justify-center items-center min-h-[300px]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#1F2A44]"></div>
          </div>
        ) : (
          properties.map((property) => (
            <div key={property._id} className="mb-4">
              <div className="flex flex-col md:flex-row justify-between gap-4 bg-white p-4 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">

                {/* 1. Image Section (Clean) */}
                <div className="flex-shrink-0">
                  <img
                    src={property?.uploadedPhotos?.[0] ?? ""}
                    alt="Property"
                    className="w-32 h-32 md:w-40 md:h-40 rounded-xl object-cover border border-gray-50"
                  />
                </div>

                {/* 2. Content Section (Tag is here now) */}
                <div className="flex flex-col flex-grow gap-1 min-w-0">
                  {/* Management Tag */}
                  <div className="mb-2">
                    <span
                      className={`px-3 py-1 rounded-md border text-[10px] font-bold uppercase tracking-wider shadow-sm ${property.handelPropertyBy === "PropertyLeTeam"
                        ? "bg-blue-50 border-blue-500 text-blue-600" 
                        : property.handelPropertyBy === "Customer"
                          ? "bg-green-50 border-green-500 text-green-600" 
                          : "bg-yellow-50 border-yellow-500 text-yellow-600" 
                        }`}
                    >
                      {property.handelPropertyBy === "PropertyLeTeam"
                        ? "PropertyLe Team"
                        : property.handelPropertyBy === "Customer"
                          ? "Owner Managed"
                          : "Pending Confirmation"}
                    </span>
                  </div>

                  <h3 className="text-lg font-bold text-gray-900 truncate">
                    {property?.uploadBy?.name ?? "Unknown Owner"}
                  </h3>

                  <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
                    <p className="text-xs text-gray-500 font-medium capitalize flex items-center gap-1">
                      <span className="text-gray-400">Type:</span> {property?.propertyType ?? "-"}
                    </p>
                    <p className="text-xs text-gray-500 font-medium capitalize flex items-center gap-1">
                      <span className="text-gray-400">Furnishing:</span> {property?.furnishing ?? "-"}
                    </p>
                  </div>
                  {/* Web Detail Page Link */}
                  {/* Web Detail Page Link Button */}
                  {/* Web Detail Page Link Button */}
<a
  href={`${webBaseUrl}/property/${property?.slug || property?._id}`}
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 mt-2 bg-blue-50 text-blue-600 hover:bg-blue-600 hover:text-white rounded-lg text-xs font-bold border border-blue-200 shadow-sm transition-all duration-200 w-fit"
>
  <span>View Detail</span>
  <span className="text-sm">↗</span>
</a>




{/* 
                  <div
                    className="text-sm text-gray-600 mt-2 line-clamp-2 leading-relaxed"
                    dangerouslySetInnerHTML={{
                      __html: property?.description ?? "-",
                    }}
                  ></div> */}
                </div>

                {/* 3. Action Buttons Section (Clean & Aligned) */}
                <div className="flex flex-col justify-between md:items-end min-w-[160px] gap-3">
                  {/* Status Dropdown */}
                  <select
                    value={property.status}
                    onChange={(e) => handleStatusChange(property?._id, e?.target?.value)}
                    className={`w-full px-3 py-2 rounded-lg border text-xs font-bold transition-all focus:ring-2 focus:ring-blue-100 outline-none ${property.status === "approved"
                      ? "bg-green-50 border-green-200 text-green-700"
                      : "bg-blue-50 border-blue-200 text-blue-700"
                      }`}
                  >
                    <option value="approved">Approved</option>
                    <option value="sold">Sold</option>
                    <option value="disable">Disable Property</option>
                  </select>

                  {/* Edit/Delete Grid */}
                  <div className="grid grid-cols-2 gap-2 w-full">
                    <Link
                      to={`/properties/edit/${property._id}`}
                      className="flex items-center justify-center py-2 bg-slate-800 text-white rounded-lg text-[11px] font-bold hover:bg-slate-900 transition-colors shadow-sm"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => setDeleteModal({ open: true, propertyId: property._id })}
                      className="flex items-center justify-center py-2 text-red-600 bg-red-50 border border-red-100 rounded-lg text-[11px] font-bold hover:bg-red-600 hover:text-white transition-all"
                    >
                      Delete
                    </button>
                  </div>

                  {/* Handle Property Action */}
                  <button
                    onClick={() => setAssignModal({
                      open: true,
                      propertyId: property._id,
                      currentOwner: property.handelPropertyBy
                    })}
                    className="w-full py-2 bg-white text-gray-700 border border-gray-300 rounded-lg text-[11px] font-bold hover:border-blue-500 hover:text-blue-600 transition-all flex items-center justify-center gap-1"
                  >
                    ⚙ Handle Management
                  </button>

                  {/* Toggle Details */}
                  {/* <button
                    onClick={() => toggleRow(property._id)}
                    className="text-[10px] font-extrabold text-gray-400 uppercase tracking-tighter hover:text-blue-600 transition-colors"
                  >
                    {expandedRows[property._id] ? "Hide Info ▲" : "Full Details ▼"}
                  </button> */}
                </div>
              </div>

              {/* Expanded Section (Premium Look) */}
              {expandedRows[property._id] && (
                <div className="bg-white border-x border-b rounded-b-2xl p-6 shadow-inner animate-in slide-in-from-top-2 duration-300">
                  {/* ... (Your detailed grid here) ... */}
                </div>
              )}
            </div>
          ))
        )}

        <ToastContainer position="top-right" autoClose={3000} />

        {/* Pagination */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-2">
          <div className="text-sm font-bold text-gray-400">
            Showing data{" "}
            <span className="font-medium">{(pageNo - 1) * pageSize + 1}</span>{" "}
            to{" "}
            <span className="font-medium">
              {Math.min(pageNo * pageSize, totalCount)}
            </span>{" "}
            of <span className="font-medium">{totalCount}</span>
          </div>

          <div className="flex items-center space-x-1 text-sm font-bold text-gray-700">
            <button
              className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-400 disabled:opacity-50"
              onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
              disabled={pageNo === 1}
            >
              &laquo;
            </button>

            {getPageNumbers().map((page) => (
              <button
                key={page}
                className={`px-3 py-1 rounded ${page === pageNo
                  ? "bg-orange-500 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-400"
                  }`}
                onClick={() => setPageNo(page)}
              >
                {page}
              </button>
            ))}

            <button
              className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-400 disabled:opacity-50"
              onClick={() =>
                setPageNo((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={pageNo === totalPages}
            >
              &raquo;
            </button>
          </div>
          <div></div>
        </div>
      </div>

      {/* 🔹 Modal */}
      {metaModal.open && (
        <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl p-8 w-full max-w-2xl">
            {" "}
            {/* ⬅ bigger width */}
            <h2 className="text-xl font-bold mb-6">Add Metadata</h2>
            <div className="flex flex-col gap-4">
              {/* Title */}
              <input
                type="text"
                placeholder="Title"
                value={metaModal.title}
                onChange={(e) =>
                  setMetaModal({ ...metaModal, title: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-base focus:outline-none focus:ring-2 focus:ring-orange-500"
              />

              {/* Description */}
              <textarea
                placeholder="Description"
                value={metaModal.description}
                onChange={(e) =>
                  setMetaModal({ ...metaModal, description: e.target.value })
                }
                className="w-full border border-gray-300 rounded-lg px-4 py-3 h-40 resize-y text-base focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>
            {/* Actions */}
            <div className="flex justify-end gap-4 mt-6">
              <button
                onClick={() =>
                  setMetaModal({
                    open: false,
                    propertyId: null,
                    title: "",
                    description: "",
                  })
                }
                className="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveMeta}
                className="px-6 py-2 rounded-lg bg-orange-500 hover:bg-orange-600 text-white shadow"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}


      {deleteModal.open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
            <h2 className="text-lg font-bold text-gray-800 mb-3">
              Confirm Delete
            </h2>
            <p className="text-sm text-gray-600">
              Are you sure you want to delete this property?
              This action <span className="font-semibold text-red-500">cannot be undone</span>.
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() =>
                  setDeleteModal({ open: false, propertyId: null })
                }
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteProperty}
                className="px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {verifyModal.open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
            <h2 className="text-lg font-bold text-gray-800 mb-3">
              Confirm Verification
            </h2>
            <p className="text-sm text-gray-600">
              Are you sure you want to verify this property?
              Once verified, it will be marked as <span className="font-semibold text-green-600">trusted</span>.
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() =>
                  setVerifyModal({ open: false, propertyId: null })
                }
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleVerifyProperty(verifyModal.propertyId);
                  setVerifyModal({ open: false, propertyId: null });
                }}
                className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white"
              >
                Yes, Verify
              </button>
            </div>
          </div>
        </div>
      )}


      {assignModal.open && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-[999] p-4 transition-all">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">

            {/* Header Section */}
            <div className="relative p-6 pb-0 text-center">
              <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-sm rotate-3">
                <FiUsers size={28} />
              </div>
              <h2 className="text-2xl font-extrabold text-gray-800 tracking-tight">Management Assignment</h2>
              <p className="text-sm text-gray-500 mt-2 px-4">
                Select who will handle the leads and inquiries for this property listing.
              </p>
            </div>

            {/* Options Container */}
            <div className="p-6 space-y-3">
              {/* Customer Option */}
              <button
                onClick={() => handleUpdateAssignment(assignModal.propertyId, "Customer")}
                className={`w-full group relative flex items-center gap-4 p-4 rounded-2xl border-2 transition-all duration-200 ${assignModal?.handelPropertyBy === 'Customer'
                  ? 'border-blue-600 bg-blue-50/50 shadow-md'
                  : 'border-gray-100 hover:border-gray-200 hover:bg-gray-50'
                  }`}
              >
                <div className={`p-3 rounded-xl transition-colors ${assignModal?.handelPropertyBy === 'Customer' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-gray-200'
                  }`}>
                  <FiUser size={20} />
                </div>
                <div className="text-left">
                  <h4 className={`font-bold text-sm ${assignModal?.handelPropertyBy === 'Customer' ? 'text-blue-900' : 'text-gray-700'}`}>
                    End Customer
                  </h4>
                  <p className="text-xs text-gray-400 font-medium">Owner handles all inquiries directly</p>
                </div>
                {assignModal?.handelPropertyBy === 'Customer' && (
                  <div className="absolute right-4 text-blue-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                )}
              </button>

              {/* Team Option */}
              <button
                onClick={() => handleUpdateAssignment(assignModal.propertyId, "PropertyLeTeam")}
                className={`w-full group relative flex items-center gap-4 p-4 rounded-2xl border-2 transition-all duration-200 ${assignModal?.handelPropertyBy === 'PropertyLeTeam'
                  ? 'border-blue-600 bg-blue-50/50 shadow-md'
                  : 'border-gray-100 hover:border-gray-200 hover:bg-gray-50'
                  }`}
              >
                <div className={`p-3 rounded-xl transition-colors ${assignModal?.handelPropertyBy === 'PropertyLeTeam' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-gray-200'
                  }`}>
                  <FiUsers size={20} />
                </div>
                <div className="text-left">
                  <h4 className={`font-bold text-sm ${assignModal?.handelPropertyBy === 'PropertyLeTeam' ? 'text-blue-900' : 'text-gray-700'}`}>
                    Property Team
                  </h4>
                  <p className="text-xs text-gray-400 font-medium">Internal agents manage the listing</p>
                </div>
                {assignModal?.handelPropertyBy === 'PropertyLeTeam' && (
                  <div className="absolute right-4 text-blue-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                )}
              </button>
            </div>

            {/* Footer */}
            <div className="p-4 bg-gray-50 flex flex-col gap-2">
              <button
                onClick={() => setAssignModal({ open: false, propertyId: null })}
                className="w-full py-3 text-sm font-bold text-gray-500 hover:text-gray-700 transition-colors uppercase tracking-widest"
              >
                Cancel & Close
              </button>
            </div>
          </div>
        </div>
      )}
            {/* Disable Property Confirmation Modal */}
      {disableModal.open && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl space-y-4 animate-in fade-in zoom-in duration-200">
            <h3 className="text-lg font-bold text-gray-800">
              Confirm Disable Property
            </h3>

            <p className="text-sm text-gray-600">
              Are you sure you want to disable this property?
            </p>

            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={() => setDisableModal({ open: false, propertyId: null })}
                className="px-4 py-2 border rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-all"
              >
                Cancel
              </button>

              <button
                onClick={confirmDisableProperty}
                className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl text-sm font-bold transition-all shadow-md"
              >
                Confirm Disable
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default AllProperties;
